export const specialOffers = [
    {
        id: 100,
        title: "Pioneer DJ headphones",
        firstImage:"/images/products/special-offers/s1.jpg",
        secondImage:"/images/products/special-offers/s2.jpg",
        images: [
            "/images/products/special-offers/s1.jpg",
            "/images/products/special-offers/s2.jpg",
            "/images/products/special-offers/s3.jpg",
            "/images/products/special-offers/s4.jpg"
        ],
        price: 50,
        discount: 30,
        rating:4.1,
        reviews: "4,521",
    },
    {
        id: 101,
        title: "Hoco earphone",
        firstImage:"/images/products/special-offers/s3.jpg",
        secondImage:"/images/products/special-offers/s4.jpg",
        images: [
            "/images/products/special-offers/s3.jpg",
            "/images/products/special-offers/s4.jpg",
            "/images/products/special-offers/s1.jpg",
            "/images/products/special-offers/s2.jpg"
        ],
        price: 40,
        discount: 20,
        rating:4.1,
        reviews: "1,870",
    },
    {
        id: 102,
        title: "Samsung tablet",
        firstImage:"/images/products/special-offers/s5.jpg",
        secondImage:"/images/products/special-offers/s6.jpg",
        images: [
            "/images/products/special-offers/s5.jpg",
            "/images/products/special-offers/s6.jpg",
        ],
        price: 200,
        discount: 40,
        rating:4.5,
        reviews: "584",
    },
    {
        id: 103,
        title: "Samsung Galaxy phone",
        firstImage:"/images/products/special-offers/s7.jpg",
        secondImage:"/images/products/special-offers/s8.jpg",
        images: [
            "/images/products/special-offers/s7.jpg",
            "/images/products/special-offers/s8.jpg",
        ],
        price: 550,
        discount: 20,
        rating:4.8,
        reviews: "8,170",
    },
]
